// import React, { useEffect, useState } from "react";
// import { db } from "../firebase";
// import {
//   collection,
//   doc,
//   onSnapshot,
//   runTransaction,
//   serverTimestamp,
// } from "firebase/firestore";
// import toast from "react-hot-toast";
// import { getAffiliateBonusState, getWithdrawableBalance } from "../lib/affiliateBonus";

// function validateAddress(val, type) {
//   if (!val) return false;
//   if (type === "trc20") return /^T[a-zA-Z0-9]{33}$/.test(val.trim());
//   if (type === "bep20") return /^0x[a-fA-F0-9]{40}$/.test(val.trim());
//   if (type === "binance") return /^[0-9]{6,}$/.test(val.trim());
//   return false;
// }

// export default function WithdrawPage({ user }) {
//   const [amount, setAmount] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [userProfile, setUserProfile] = useState(null);
//   const [method, setMethod] = useState("");
//   const [wallet, setWallet] = useState("");

//   useEffect(() => {
//     if (!user?.uid) return undefined;
//     return onSnapshot(doc(db, "users", user.uid), (snap) => {
//       setUserProfile(snap.exists() ? snap.data() : null);
//     });
//   }, [user?.uid]);

//   const balance = Number(userProfile?.balance || 0);
//   const availableToWithdraw = getWithdrawableBalance(userProfile || {});
//   const affiliateState = getAffiliateBonusState(userProfile || {});

//   const handleWithdraw = async () => {
//     const withdrawAmount = parseFloat(amount);
//     if (Number.isNaN(withdrawAmount)) return toast.error("Enter a valid amount.");
//     if (withdrawAmount <= 0) return toast.error("Amount must be greater than 0.");
//     if (!/^\d+(\.\d{1,2})?$/.test(amount)) return toast.error("Max 2 decimals allowed.");
//     if (withdrawAmount > availableToWithdraw) {
//       return toast.error("Amount exceeds your withdrawable balance.");
//     }
//     if (withdrawAmount < 5) return toast.error("Minimum withdrawal is $5.");
//     if (!method) {
//       return toast.error("Select withdrawal method (TRC20/BEP20/Binance ID).");
//     }
//     if (!wallet) {
//       return toast.error(
//         method === "binance" ? "Enter your Binance UID." : "Enter your wallet address.",
//       );
//     }
//     if (!validateAddress(wallet, method)) {
//       return toast.error(
//         method === "binance" ? "Invalid Binance UID." : "Invalid wallet address.",
//       );
//     }

//     setLoading(true);
//     try {
//       const userRef = doc(db, "users", user.uid);
//       const withdrawRequestRef = doc(collection(db, "withdraw_requests"));

//       await runTransaction(db, async (transaction) => {
//         const snap = await transaction.get(userRef);
//         if (!snap.exists()) {
//           throw new Error("User not found.");
//         }

//         const data = snap.data() || {};
//         const currentAvailable = getWithdrawableBalance(data);
//         if (withdrawAmount > currentAvailable) {
//           throw new Error("Amount exceeds your withdrawable balance.");
//         }

//         const update = {
//           balance: Number((Number(data.balance || 0) - withdrawAmount).toFixed(2)),
//           updatedAt: serverTimestamp(),
//         };

//         const depositBonusLocked =
//           Number(data.bonusAmount ?? data.depositBonus ?? 0) > 0 &&
//           Number(data.turnoverRequired || 0) > Number(data.turnoverCompleted || 0);
//         const reservedFromDepositAmount = depositBonusLocked
//           ? Math.min(withdrawAmount, Number(data.depositAmount || 0))
//           : 0;

//         if (depositBonusLocked) {
//           update.depositAmount = Math.max(
//             0,
//             Number((Number(data.depositAmount || 0) - withdrawAmount).toFixed(2)),
//           );
//         }

//         transaction.update(userRef, update);
//         transaction.set(withdrawRequestRef, {
//           userId: user.uid,
//           amount: withdrawAmount,
//           status: "pending",
//           requestedAt: new Date(),
//           createdAt: serverTimestamp(),
//           processedAt: null,
//           txId: null,
//           adminNote: null,
//           method,
//           wallet,
//           requestType: "player_balance",
//           fundsReserved: true,
//           reservedFromDepositAmount,
//         });
//       });

//       setAmount("");
//       setWallet("");
//       setMethod("");
//       toast.success("Withdrawal requested!");
//     } catch (error) {
//       toast.error(error?.message || "Failed to request withdrawal.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="w-full max-w-md mx-auto mt-12 bg-[#171e2e] bg-gradient-to-br from-[#171e2e] to-[#232e45] p-7 rounded-3xl shadow-2xl text-white border-2 border-lime-400/50">
//       <div className="mb-6">
//         <div className="font-extrabold text-lime-300 text-2xl mb-2 drop-shadow">
//           Withdraw Funds
//         </div>
//         <div className="mb-2 text-sm text-yellow-300 font-bold">
//           Minimum withdrawal amount: $5
//         </div>
//         <div className="mb-2 text-base">
//           Balance:{" "}
//           <span className="text-lime-200 font-black text-xl">
//             ${balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}
//           </span>
//         </div>
//         <div className="mb-2 text-base">
//           Withdrawable now:{" "}
//           <span className="text-emerald-300 font-black text-xl">
//             ${availableToWithdraw.toLocaleString(undefined, { minimumFractionDigits: 2 })}
//           </span>
//         </div>
//         {affiliateState.locked > 0 ? (
//           <div className="rounded-xl border border-amber-400/30 bg-amber-400/10 px-4 py-3 text-sm text-amber-100">
//             Affiliate bonus locked: {affiliateState.locked.toFixed(2)} USDT. Unlock after {affiliateState.required.toFixed(0)} turnover.
//           </div>
//         ) : null}

//         <div className="mb-4 mt-4">
//           <label className="block text-lime-200 text-base font-bold mb-1">
//             Withdraw Method
//           </label>
//           <select
//             value={method}
//             onChange={(e) => setMethod(e.target.value)}
//             className="w-full bg-[#151b29] border-2 border-lime-400/40 text-lime-100 rounded-xl py-3 px-4 mb-4 focus:border-lime-400 transition"
//           >
//             <option value="">Select method</option>
//             <option value="trc20">USDT TRC20</option>
//             <option value="bep20">USDT BEP20</option>
//             <option value="binance">Binance UID</option>
//           </select>

//           {method ? (
//             <>
//               <label className="block text-lime-200 text-base font-bold mb-1">
//                 {method === "binance" ? "Your Binance UID" : "Wallet Address"}
//               </label>
//               <input
//                 className="w-full bg-[#151b29] border-2 border-lime-400/40 text-white rounded-xl py-3 px-4 mb-4 text-base focus:border-lime-400 transition placeholder:text-slate-400"
//                 type={method === "binance" ? "number" : "text"}
//                 placeholder={
//                   method === "trc20"
//                     ? "T... (TRC20 address)"
//                     : method === "bep20"
//                       ? "0x... (BEP20 address)"
//                       : "Binance UID (numbers only)"
//                 }
//                 value={wallet}
//                 onChange={(e) => setWallet(e.target.value)}
//               />
//             </>
//           ) : null}

//           <label className="block text-lime-200 text-base font-bold mb-1">
//             Amount
//           </label>
//           <input
//             type="number"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//             placeholder="0.00"
//             className="w-full bg-[#151b29] border-2 border-lime-400/40 text-white rounded-xl py-3 px-4 text-base focus:border-lime-400 transition placeholder:text-slate-400"
//           />
//         </div>
//       </div>

//       <button
//         onClick={handleWithdraw}
//         disabled={loading}
//         className="w-full bg-lime-500 hover:bg-lime-400 disabled:opacity-60 text-black py-3 rounded-xl font-black text-lg transition"
//       >
//         {loading ? "Submitting..." : "Request Withdrawal"}
//       </button>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  onSnapshot,
  runTransaction,
  serverTimestamp,
} from "firebase/firestore";
import toast from "react-hot-toast";
import {
  getAffiliateBonusState,
  getWithdrawableBalance,
} from "../lib/affiliateBonus";

const MIN_WITHDRAW = 5;

function normalizeMethod(method) {
  return {
    id: method.id,
    userPaymentMethodId: method.user_payment_method_id,
    name: method.name,
    networkName: method.network_name,
    networkTypeName: method.network_type_name,
    chainId: method.chain_id,
    logo: method.logo,
    usdRate: method.usd_rate,
    withdrawStatus: method.withdraw_status,
    depositStatus: method.deposit_status,
    label: `${method.name} ${method.network_name}`,
  };
}

export default function WithdrawPage({ user }) {
  const API_URL = process.env.REACT_APP_API_URL;

  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingMethods, setLoadingMethods] = useState(false);
  const [validatingAddress, setValidatingAddress] = useState(false);

  const [userProfile, setUserProfile] = useState(null);
  const [withdrawMethods, setWithdrawMethods] = useState([]);
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState("");
  const [wallet, setWallet] = useState("");
  const [validatedAddress, setValidatedAddress] = useState(null);

  useEffect(() => {
    if (!user?.uid) return undefined;

    return onSnapshot(doc(db, "users", user.uid), (snap) => {
      setUserProfile(snap.exists() ? snap.data() : null);
    });
  }, [user?.uid]);

  useEffect(() => {
    if (!API_URL) {
      toast.error("Backend API URL is not configured.");
      return undefined;
    }

    let cancelled = false;

    async function loadWithdrawMethods() {
      setLoadingMethods(true);

      try {
        const res = await fetch(
          `${API_URL}/api/cryptrum/payment-methods?type=withdraw`,
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.error || "Failed to load withdrawal methods.");
        }

        const rows = data?.data?.data || [];
        const activeMethods = rows
          .filter((method) => Number(method.withdraw_status) === 1)
          .map(normalizeMethod);

        if (cancelled) return;

        setWithdrawMethods(activeMethods);

        const preferred =
          activeMethods.find(
            (method) =>
              method.name === "USDT" && method.networkName === "TRC20",
          ) ||
          activeMethods.find((method) => method.name === "USDT") ||
          activeMethods[0];

        if (preferred) {
          setSelectedPaymentMethodId(String(preferred.id));
        }
      } catch (error) {
        if (!cancelled) {
          toast.error(error?.message || "Failed to load withdrawal methods.");
        }
      } finally {
        if (!cancelled) {
          setLoadingMethods(false);
        }
      }
    }

    loadWithdrawMethods();

    return () => {
      cancelled = true;
    };
  }, [API_URL]);

  const selectedMethod = useMemo(() => {
    return withdrawMethods.find(
      (method) => String(method.id) === String(selectedPaymentMethodId),
    );
  }, [withdrawMethods, selectedPaymentMethodId]);

  const balance = Number(userProfile?.balance || 0);
  const availableToWithdraw = getWithdrawableBalance(userProfile || {});
  const affiliateState = getAffiliateBonusState(userProfile || {});

  const resetValidation = () => {
    setValidatedAddress(null);
  };

  const handleValidateAddress = async () => {
    if (!API_URL) return toast.error("Backend API URL is not configured.");
    if (!selectedMethod)
      return toast.error("Please select a withdrawal network.");
    if (!wallet.trim()) return toast.error("Please enter your wallet address.");

    setValidatingAddress(true);
    setValidatedAddress(null);

    try {
      const res = await fetch(`${API_URL}/api/cryptrum/validate-address`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paymentMethodId: Number(selectedMethod.id),
          address: wallet.trim(),
        }),
      });

      const data = await res.json();

      if (!res.ok || !data?.status) {
        throw new Error(data.error || data.msg || "Invalid wallet address.");
      }

      setValidatedAddress(data.data || data);
      toast.success("Wallet address is valid.");
    } catch (error) {
      setValidatedAddress(null);
      toast.error(error?.message || "Invalid wallet address.");
    } finally {
      setValidatingAddress(false);
    }
  };

  const handleWithdraw = async () => {
    const withdrawAmount = Number(amount);

    if (!user?.uid) return toast.error("Please log in first.");
    if (!selectedMethod) return toast.error("Select a withdrawal method.");
    if (!wallet.trim()) return toast.error("Enter your wallet address.");
    if (!validatedAddress) {
      return toast.error("Please validate your wallet address first.");
    }
    if (Number.isNaN(withdrawAmount))
      return toast.error("Enter a valid amount.");
    if (withdrawAmount <= 0)
      return toast.error("Amount must be greater than 0.");
    if (!/^\d+(\.\d{1,2})?$/.test(amount)) {
      return toast.error("Max 2 decimals allowed.");
    }
    if (withdrawAmount < MIN_WITHDRAW) {
      return toast.error(`Minimum withdrawal is $${MIN_WITHDRAW}.`);
    }
    if (withdrawAmount > availableToWithdraw) {
      return toast.error("Amount exceeds your withdrawable balance.");
    }

    setLoading(true);

    try {
      const userRef = doc(db, "users", user.uid);
      const withdrawRequestRef = doc(collection(db, "withdraw_requests"));

      await runTransaction(db, async (transaction) => {
        const snap = await transaction.get(userRef);

        if (!snap.exists()) {
          throw new Error("User not found.");
        }

        const data = snap.data() || {};
        const currentAvailable = getWithdrawableBalance(data);

        if (withdrawAmount > currentAvailable) {
          throw new Error("Amount exceeds your withdrawable balance.");
        }

        const depositBonusLocked =
          Number(data.bonusAmount ?? data.depositBonus ?? 0) > 0 &&
          Number(data.turnoverRequired || 0) >
            Number(data.turnoverCompleted || 0);

        const reservedFromDepositAmount = depositBonusLocked
          ? Math.min(withdrawAmount, Number(data.depositAmount || 0))
          : 0;

        const update = {
          balance: Number(
            (Number(data.balance || 0) - withdrawAmount).toFixed(2),
          ),
          updatedAt: serverTimestamp(),
        };

        if (depositBonusLocked) {
          update.depositAmount = Math.max(
            0,
            Number(
              (Number(data.depositAmount || 0) - withdrawAmount).toFixed(2),
            ),
          );
        }

        transaction.update(userRef, update);

        transaction.set(withdrawRequestRef, {
          userId: user.uid,
          amount: withdrawAmount,
          status: "pending",
          requestedAt: new Date(),
          createdAt: serverTimestamp(),
          processedAt: null,

          gateway: "cryptrum",
          requestType: "player_balance",
          fundsReserved: true,
          reservedFromDepositAmount,

          paymentMethodId: Number(selectedMethod.id),
          userPaymentMethodId: selectedMethod.userPaymentMethodId || null,
          currency: selectedMethod.name,
          network: selectedMethod.networkName,
          networkType: selectedMethod.networkTypeName || null,
          chainId: selectedMethod.chainId || null,

          wallet: wallet.trim(),
          toAddress: wallet.trim(),
          addressValidation: validatedAddress,

          txId: null,
          withdrawCode: null,
          adminNote: null,
        });
      });

      setAmount("");
      setWallet("");
      setValidatedAddress(null);
      toast.success("Withdrawal request submitted for admin review.");
    } catch (error) {
      toast.error(error?.message || "Failed to request withdrawal.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto mt-12 bg-[#171e2e] bg-gradient-to-br from-[#171e2e] to-[#232e45] p-7 rounded-3xl shadow-2xl text-white border-2 border-lime-400/50">
      <div className="mb-6">
        <div className="font-extrabold text-lime-300 text-2xl mb-2 drop-shadow">
          Withdraw Funds
        </div>

        <div className="mb-2 text-sm text-yellow-300 font-bold">
          Minimum withdrawal amount: ${MIN_WITHDRAW}
        </div>

        <div className="mb-2 text-base">
          Balance:{" "}
          <span className="text-lime-200 font-black text-xl">
            ${balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </span>
        </div>

        <div className="mb-2 text-base">
          Withdrawable now:{" "}
          <span className="text-emerald-300 font-black text-xl">
            $
            {availableToWithdraw.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </span>
        </div>

        {affiliateState.locked > 0 ? (
          <div className="rounded-xl border border-amber-400/30 bg-amber-400/10 px-4 py-3 text-sm text-amber-100">
            Affiliate bonus locked: {affiliateState.locked.toFixed(2)} USDT.
            Unlock after {affiliateState.required.toFixed(0)} turnover.
          </div>
        ) : null}

        <div className="mb-4 mt-4">
          <label className="block text-lime-200 text-base font-bold mb-1">
            Withdraw Network
          </label>

          <select
            value={selectedPaymentMethodId}
            onChange={(e) => {
              setSelectedPaymentMethodId(e.target.value);
              resetValidation();
            }}
            disabled={loadingMethods}
            className="w-full bg-[#151b29] border-2 border-lime-400/40 text-lime-100 rounded-xl py-3 px-4 mb-4 focus:border-lime-400 transition"
          >
            <option value="">
              {loadingMethods ? "Loading methods..." : "Select method"}
            </option>

            {withdrawMethods.map((method) => (
              <option key={method.id} value={method.id}>
                {method.label}
              </option>
            ))}
          </select>

          {selectedMethod ? (
            <div className="mb-4 rounded-xl border border-lime-400/20 bg-black/20 px-4 py-3 text-sm text-slate-200">
              <div>
                Currency:{" "}
                <span className="font-bold text-lime-300">
                  {selectedMethod.name}
                </span>
              </div>
              <div>
                Network:{" "}
                <span className="font-bold text-lime-300">
                  {selectedMethod.networkName}
                </span>
              </div>
              {/* <div>
                Payment Method ID:{" "}
                <span className="font-bold text-lime-300">
                  {selectedMethod.id}
                </span>
              </div> */}
            </div>
          ) : null}

          <label className="block text-lime-200 text-base font-bold mb-1">
            Wallet Address
          </label>

          <input
            className="w-full bg-[#151b29] border-2 border-lime-400/40 text-white rounded-xl py-3 px-4 mb-3 text-base focus:border-lime-400 transition placeholder:text-slate-400"
            type="text"
            placeholder={
              selectedMethod?.networkName === "TRC20"
                ? "T... USDT TRC20 address"
                : selectedMethod?.networkName === "BEP20" ||
                    selectedMethod?.networkName === "ERC20"
                  ? "0x... wallet address"
                  : "Enter wallet address"
            }
            value={wallet}
            onChange={(e) => {
              setWallet(e.target.value);
              resetValidation();
            }}
          />

          <button
            type="button"
            onClick={handleValidateAddress}
            disabled={validatingAddress || !selectedMethod || !wallet.trim()}
            className="mb-4 w-full rounded-xl border border-lime-400/40 bg-lime-400/10 py-2 font-bold text-lime-200 transition hover:bg-lime-400/20 disabled:opacity-50"
          >
            {validatingAddress ? "Validating..." : "Validate Address"}
          </button>

          {validatedAddress ? (
            <div className="mb-4 rounded-xl border border-emerald-400/30 bg-emerald-400/10 px-4 py-3 text-sm text-emerald-100">
              Address validated for {selectedMethod?.label}.
            </div>
          ) : null}

          <label className="block text-lime-200 text-base font-bold mb-1">
            Amount
          </label>

          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            className="w-full bg-[#151b29] border-2 border-lime-400/40 text-white rounded-xl py-3 px-4 text-base focus:border-lime-400 transition placeholder:text-slate-400"
          />
        </div>
      </div>

      <button
        onClick={handleWithdraw}
        disabled={loading || !validatedAddress}
        className="w-full bg-lime-500 hover:bg-lime-400 disabled:opacity-60 text-black py-3 rounded-xl font-black text-lg transition"
      >
        {loading ? "Submitting..." : "Request Withdrawal"}
      </button>
    </div>
  );
}
